import VisitsCalendarScreenContainer from '../features/containers/visits/VisitsCalendarScreenContainer';

export default function VisitsCalendar() {
  return <VisitsCalendarScreenContainer />;
}
